import React from "react";
export default function MODE() {
  return <div>Excel_MODE</div>;
}
